<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h1>The Disappeared Girl</h1>
</div>
</div>
<h3 class="sigil_not_in_toc" style="text-align: center;">Martin J. Smith</h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap225799.vue?59b9e880